function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Represents a location in the component
 * @constructor
 * @memberOf module:wdh-locations-spot
 */
var Location = /*#__PURE__*/function () {
  function Location() {
    _classCallCheck(this, Location);
    /**
     * @type {string}
     */
    this.UniqueId = '';
    /**
     * @type {string}
     */
    this.Name = '';
    /**
     * @type {number}
     */
    this.Latitude = 0;
    /**
     * @type {number}
     */
    this.Longitude = 0;
    /**
     * @type {string}
     */
    this.Address = '';

    /**
     * @type {string}
     */
    this.City = '';

    /**
     * @type {string}
     */
    this.Country = '';

    /**
     * @type {string}
     */
    this.Description = '';

    /**
     * @type {string}
     */
    this.Email = '';

    /**
     * @type {string}
     */
    this.FormattedAddress = '';

    /**
     * @type {string}
     */
    this.Homepage = '';

    /**
     * @type {number}
     */
    this.LocationType = -1;

    /**
     * @type {string}
     */
    this.OpeningHours = '';

    /**
     * @type {string}
     */
    this.Phone = '';

    /**
     * @type {string}
     */
    this.PostalCode = '';

    /**
     * @type {string}
     */
    this.Region = '';

    /**
     * @type {number}
     */
    this.Distance = 0;

    /**
     * US Oticon.com
     * @type {boolean}
     */
    this.RiskFreeTrial = false;

    /**
     * US Oticon.com
     * @type {boolean}
     */
    this.SoldQty = false;

    /**
     * @type {string}
     */
    this.CustomerNumber = '';
  }
  return _createClass(Location, [{
    key: "lat",
    get: function get() {
      return this.Latitude;
    }
  }, {
    key: "lng",
    get: function get() {
      return this.Longitude;
    }
  }, {
    key: "isDefault",
    value: function isDefault() {
      return this.lat === 0 && this.lng === 0;
    }
  }, {
    key: "equals",
    value: function equals(location) {
      return location.UniqueId === this.UniqueId;
    }
  }, {
    key: "contactDetailsToString",
    value: function contactDetailsToString(fields) {
      var _this = this;
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ';';
      var details = '';
      fields.forEach(function (field) {
        details += "".concat(_this[field]).concat(delimiter);
      });
      return details;
    }
  }], [{
    key: "fromWebserviceData",
    value: function fromWebserviceData(data) {
      var loc = new Location();
      loc.Name = data.Name;
      loc.UniqueId = data.UniqueId;
      loc.Latitude = data.Latitude;
      loc.Longitude = data.Longitude;
      loc.Address = data.Address;
      loc.City = data.City;
      loc.Country = data.Country;
      loc.Description = data.Description;
      loc.Email = data.Email;
      loc.FormattedAddress = data.FormattedAddress;
      loc.Homepage = data.Homepage;
      loc.LocationType = data.LocationType;
      loc.OpeningHours = data.OpeningHours;
      loc.Phone = data.Phone;
      loc.PostalCode = data.PostalCode;
      loc.Region = data.Region;
      loc.RiskFreeTrial = data.RiskFreeTrial.toString();
      loc.SoldQty = data.SoldQty.toString();
      loc.CustomerNumber = data.CustomerNumber;
      return loc;
    }
  }, {
    key: "fromGooglePlace",
    value: function fromGooglePlace(place) {
      var loc = new Location();
      loc.Latitude = place.geometry.location.lat();
      loc.Longitude = place.geometry.location.lng();
      loc.Name = place.name;
      return loc;
    }
  }, {
    key: "fromSettings",
    value: function fromSettings(data) {
      var loc = new Location();
      loc.Latitude = data.Latitude;
      loc.Longitude = data.Longitude;
      return loc;
    }
  }, {
    key: "fromGeolocation",
    value: function fromGeolocation(data) {
      var loc = new Location();
      loc.Latitude = data.latitude;
      loc.Longitude = data.longitude;
      return loc;
    }
  }, {
    key: "fromObject",
    value: function fromObject(object) {
      var loc = new Location();
      Object.assign(loc, object);
      return loc;
    }
  }, {
    key: "fromCoordinateArray",
    value: function fromCoordinateArray(coord) {
      var loc = new Location();
      var _coord = _slicedToArray(coord, 2);
      loc.Latitude = _coord[0];
      loc.Longitude = _coord[1];
      return loc;
    }
  }]);
}();
export default Location;